module.exports = __webpack_public_path__ + "img/multiple-surveys.bffcd5b1.svg";